import add from 'date-fns/add';
import format from 'date-fns/format';
import { Agreement, CreditNote, Invoice, PendingAgreement } from 'interfaces/ApiTypeAliases';

const todayPlusThirtyDays = format(add(new Date(), { days: 5 }), 'yyyy-MM-dd');

export const unionAccount: Agreement = {
  type: 'GiroAgreement',
  agreementId: 365,
  accountId: 155,
  externalAgreementId: '5e546bdd-852b-4975-acb8-8e9045c311fe',
  billingAccountNumber: 'uri://ras/204720230',
  frequency: 'Quarterly',
  payingFor: ['TV'],
  affiliations: ['Union'],
  lockedUntilUtc: '2023-01-17', // Used in storybook
};

export const creditCardAgreement: Agreement = {
  creditCard: {
    cardNumberMasked: 'XXXXXXXXXXXX0000',
    cardNumberPrefix: '471110',
    expirationDate: todayPlusThirtyDays, // expires soon
    cardStatus: 'Active',
    creditCardType: 'Visa',
  },
  type: 'CreditCardAgreement',
  agreementId: 1122,
  accountId: 810,
  externalAgreementId: '1e0ea179-87fc-442c-9d59-1d42b6226ca9',
  billingAccountNumber: 'uri://ras/204386275',
  lockedUntilUtc: null,
  frequency: 'Quarterly',
  payingFor: ['MOBILE'],
  affiliations: ['Union'],
};

export const agreements: Agreement[] = [
  unionAccount,
  {
    creditCard: {
      cardNumberMasked: 'XXXXXXXXXXXX0000',
      cardNumberPrefix: '471110',
      expirationDate: todayPlusThirtyDays, // expires soon
      cardStatus: 'Active',
      creditCardType: 'Visa',
    },
    type: 'CreditCardAgreement',
    agreementId: 1122,
    accountId: 810,
    externalAgreementId: '1e0ea179-87fc-442c-9d59-1d42b6226ca9',
    billingAccountNumber: 'uri://ras/204386275',
    // lockedUntilUtc: '2023-01-17',
    frequency: 'Quarterly',
    payingFor: ['MOBILE'],
    affiliations: ['Union'],
  },
  {
    type: 'MobilePayAgreement',
    agreementId: 767,
    accountId: 3,
    externalAgreementId: 'Staging-3669fcc9-3780-4231-bacb-87e194323699',
    billingAccountNumber: 'uri://ras/204145843',
    frequency: 'Quarterly',
    payingFor: ['BROADBAND'],
    affiliations: [],
  },
  {
    type: 'GiroAgreement',
    agreementId: 771,
    accountId: 7,
    externalAgreementId: '7dba7d87-93e3-48fc-a07b-4d19d3ecf4bf',
    billingAccountNumber: 'uri://ras/204391921',
    frequency: 'Quarterly',
    payingFor: ['MOBILE'],
    affiliations: [],
  },
  {
    type: 'DirectDebitAgreement',
    agreementId: 772,
    accountId: 8,
    externalAgreementId: 'ef8a1554-1172-4fb2-b8d5-77b1c098db99',
    billingAccountNumber: 'uri://ras/204392007',
    frequency: 'Monthly',
    payingFor: ['MOBILE'],
    affiliations: [],
  },
  {
    creditCard: {
      cardNumberMasked: 'XXXXXXXXXXXX1111',
      cardNumberPrefix: '471110',
      expirationDate: '2019-11-27',
      cardStatus: 'Expired',
      creditCardType: 'Visa',
    },
    type: 'CreditCardAgreement',
    agreementId: 768,
    accountId: 4,
    externalAgreementId: 'c3fefd1b-1a5e-4def-bd52-ad7b271d08a2',
    billingAccountNumber: 'uri://ras/204519743',
    frequency: 'Quarterly',
    payingFor: ['FIXED'],
    affiliations: [],
  },
  {
    creditCard: {
      cardNumberMasked: 'XXXXXXXXXXXX0000',
      cardNumberPrefix: '471110',
      expirationDate: '2022-11-27',
      cardStatus: 'Active',
      creditCardType: 'Visa',
    },
    type: 'CreditCardAgreement',
    agreementId: 768,
    accountId: 4,
    externalAgreementId: 'c3fefd1b-1a5e-4def-bd52-ad7b271d08a2',
    billingAccountNumber: 'uri://ras/204145821',
    lockedUntilUtc: null,
    frequency: 'Quarterly',
    payingFor: ['FIXED'],
    affiliations: [],
  },
  {
    type: 'MobilePayAgreement',
    agreementId: 769,
    accountId: 5,
    externalAgreementId: 'Staging-178899dd-6997-47ac-9939-753ce3074f62',
    billingAccountNumber: 'uri://ras/204297539',
    frequency: 'Quarterly',
    payingFor: ['FIXED'],
    affiliations: [],
  },
  {
    type: 'GiroAgreement',
    agreementId: 770,
    accountId: 6,
    externalAgreementId: '050a6602-4487-40b2-ad92-ea85d967b440',
    billingAccountNumber: 'uri://ras/204391295',
    frequency: 'Quarterly',
    payingFor: ['MOBILE'],
    affiliations: [],
  },
  {
    creditCard: {
      cardNumberMasked: 'XXXXXXXXXXXX0000',
      cardNumberPrefix: '457110',
      expirationDate: '2024-06-29',
      cardStatus: 'Active',
      creditCardType: 'VisaDankort',
    },
    type: 'CreditCardAgreement',
    agreementId: 778,
    accountId: 14,
    externalAgreementId: '8a655af3-cc4a-4742-8f33-31a0ca33794b',
    billingAccountNumber: 'uri://ras/204078994',
    frequency: 'Quarterly',
    payingFor: ['MOBILE_BROADBAND', 'MOBILE'],
    affiliations: [],
  },
  {
    type: 'MobilePayAgreement',
    agreementId: 777,
    accountId: 13,
    externalAgreementId: 'Staging-9cfe5b79-3ee9-484c-8b8d-bf479d78e2fb',
    billingAccountNumber: 'uri://ras/204045988',
    frequency: 'Quarterly',
    payingFor: ['FIXED', 'BROADBAND'],
    affiliations: [],
  },
  {
    creditCard: {
      cardNumberMasked: 'XXXXXXXXXXXX0000',
      cardNumberPrefix: '471110',
      expirationDate: '2024-06-29',
      cardStatus: 'Active',
      creditCardType: 'Visa',
    },
    type: 'CreditCardAgreement',
    agreementId: 776,
    accountId: 12,
    externalAgreementId: '57ccf347-c932-4aae-8091-75976d57b8ac',
    billingAccountNumber: 'uri://ras/204045289',
    frequency: 'Monthly',
    payingFor: ['BROADBAND', 'TV', 'FIXED'],
    affiliations: [],
  },
  {
    type: 'MobilePayAgreement',
    agreementId: 775,
    accountId: 11,
    externalAgreementId: 'Staging-7f8bbbb1-7962-4348-84bc-e27b71244795',
    billingAccountNumber: 'uri://ras/204044081',
    frequency: 'Quarterly',
    payingFor: ['MOBILE', 'FIXED', 'BROADBAND'],
    affiliations: [],
  },
  {
    type: 'MobilePayAgreement',
    agreementId: 774,
    accountId: 10,
    externalAgreementId: 'Staging-4d2a17e9-77a4-4c26-9019-5d8c2d9636c1',
    billingAccountNumber: 'uri://ras/204042161',
    frequency: 'Quarterly',
    payingFor: ['MOBILE', 'BROADBAND'],
    affiliations: [],
  },
  {
    creditCard: {
      cardNumberMasked: 'XXXXXXXXXXXX0000',
      cardNumberPrefix: '471110',
      expirationDate: '2024-06-29',
      cardStatus: 'Active',
      creditCardType: 'Visa',
    },
    type: 'CreditCardAgreement',
    agreementId: 773,
    accountId: 9,
    externalAgreementId: '876c0b6a-8c1f-4d63-b922-4c01df05e1c6',
    billingAccountNumber: 'uri://ras/204042112',
    frequency: 'Quarterly',
    payingFor: ['FIXED'],
    affiliations: [],
  },
];

export const pendingAgreement: PendingAgreement = {
  type: 'DirectDebitPendingAgreement',
  agreementId: 980, // could use request agreementId - but would make every agreement pending
  externalAgreementId: 'BS-650514181-980',
  createdAtUtc: '2021-03-19T09:15:28.922232Z',
  expiresAtUtc: '2021-03-22T09:15:28.922096Z',
};

export const agreementMobilePay: PendingAgreement = {
  agreementId: 699,
  externalAgreementId: 'MP-204713705-699',
  redirectUri:
    'https://sandprod-open.mobilepay.dk:443/usersettings-landing-website/?token=2d723bbc-f51f-48d7-b5cb-69699b9ee5a8&countryCode=DK&product=RecurringPayments',
};

export const agreementCreditCardNetsEasy: PendingAgreement = {
  agreementId: 712,
  externalAgreementId: 'CC204392007',
  redirectUri:
    'https://test.checkout.dibspayment.eu/hostedpaymentpage/?checkoutKey=ea13c8c71f2e4fccbe0c7652b4b548fe&pid=0008000063be6f90e5054a0c12fa8fd8&language=da-DK',
};

export const groupedStatements: { invoices: Invoice[]; creditNote: CreditNote[] } = {
  invoices: [
    {
      status: 'Outstanding',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'ManualPayment' },
      period: null,
      type: 'Invoice',
      id: 0,
      number: 1,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1234567.89, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Outstanding',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'ManualPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 1,
      number: 2,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 188.08, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Outstanding',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'AutomaticCardPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 2,
      number: 3,
      billingAccountNumber: 204386275,
      totalInclVat: { amount: 100.01, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Outstanding',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'AutomaticDirectDebitPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 3,
      number: 4,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 188.08, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Outstanding',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'MobilePayPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 4,
      number: 5,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 188.08, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Settled',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'ManualPayment' },
      period: null,
      type: 'Invoice',
      id: 5,
      number: 6,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 123456789.89, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Settled',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'ManualPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 6,
      number: 7,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 188.08, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Settled',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'AutomaticCardPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 7,
      number: 8,
      billingAccountNumber: 204386275,
      totalInclVat: { amount: 200.02, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Settled',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'AutomaticDirectDebitPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 8,
      number: 9,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 188.08, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Settled',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'MobilePayPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 9,
      number: 10,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 188.08, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Settled',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'DeductedByCredit' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 10,
      number: 11,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 188.08, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Pending',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'AutomaticDirectDebitPayment' },
      period: null,
      type: 'Invoice',
      id: 11,
      number: 12,
      billingAccountNumber: 204386275,
      totalInclVat: { amount: 1234567.89, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Pending',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'AutomaticDirectDebitPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 12,
      number: 13,
      billingAccountNumber: 204386275,
      totalInclVat: { amount: 300.03, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Overdue',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'ManualPayment' },
      period: null,
      type: 'Invoice',
      id: 13,
      number: 14,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1234567.89, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Overdue',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'ManualPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 14,
      number: 15,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 188.08, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Overdue',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'AutomaticCardPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 15,
      number: 16,
      billingAccountNumber: 204386275,
      totalInclVat: { amount: 400.04, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Overdue',
      dueDate: '2019-10-27T00:00:00',
      method: { type: 'AutomaticCardPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 16,
      number: 17,
      billingAccountNumber: 204386275,
      totalInclVat: { amount: 444.04, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Overdue',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'AutomaticDirectDebitPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 17,
      number: 18,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 188.08, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Overdue',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'MobilePayPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 18,
      number: 19,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 188.08, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Suspended',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'ManualPayment' },
      period: null,
      type: 'Invoice',
      id: 19,
      number: 20,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1234567.89, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Suspended',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'ManualPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 20,
      number: 21,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 188.08, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Suspended',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'AutomaticCardPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 21,
      number: 22,
      billingAccountNumber: 204519743,
      totalInclVat: { amount: 500.05, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Suspended',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'AutomaticDirectDebitPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 22,
      number: 23,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 188.08, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
    {
      status: 'Suspended',
      dueDate: '2019-12-27T00:00:00',
      method: { type: 'MobilePayPayment' },
      period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
      type: 'Invoice',
      id: 23,
      number: 24,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 188.08, currencyCode: 'DKK' },
      createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
      lines: [],
      products: ['BROADBAND', 'TV'],
    },
  ],
  creditNote: [
    {
      status: 'Outstanding',
      method: { type: 'NemkontoRefund' },
      type: 'CreditNote',
      id: 0,
      number: 1,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'Outstanding',
      method: { type: 'CreditCardRefund' },
      type: 'CreditNote',
      id: 1,
      number: 2,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'Outstanding',
      method: { type: 'BankTransferRefund' },
      type: 'CreditNote',
      id: 2,
      number: 3,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'Settled',
      method: { type: 'NemkontoRefund' },
      type: 'CreditNote',
      id: 3,
      number: 4,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'Settled',
      method: { type: 'CreditCardRefund' },
      type: 'CreditNote',
      id: 4,
      number: 5,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'Settled',
      method: { type: 'BankTransferRefund' },
      type: 'CreditNote',
      id: 5,
      number: 6,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'Settled',
      method: { type: 'DeductedInvoiceRefund' },
      type: 'CreditNote',
      id: 6,
      number: 7,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'Pending',
      method: { type: 'NemkontoRefund' },
      type: 'CreditNote',
      id: 7,
      number: 8,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'Pending',
      method: { type: 'CreditCardRefund' },
      type: 'CreditNote',
      id: 8,
      number: 9,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'Pending',
      method: { type: 'BankTransferRefund' },
      type: 'CreditNote',
      id: 9,
      number: 10,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'Pending',
      method: { type: 'DeductedInvoiceRefund' },
      type: 'CreditNote',
      id: 10,
      number: 11,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'FailedToPayout',
      method: { type: 'NemkontoRefund' },
      type: 'CreditNote',
      id: 11,
      number: 12,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'FailedToPayout',
      method: { type: 'CreditCardRefund' },
      type: 'CreditNote',
      id: 12,
      number: 13,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'FailedToPayout',
      method: { type: 'BankTransferRefund' },
      type: 'CreditNote',
      id: 13,
      number: 14,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'FailedToPayout',
      method: { type: 'DeductedInvoiceRefund' },
      type: 'CreditNote',
      id: 14,
      number: 15,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'NotPaidOut',
      method: { type: 'NemkontoRefund' },
      type: 'CreditNote',
      id: 15,
      number: 16,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'Suspended',
      method: { type: 'NemkontoRefund' },
      type: 'CreditNote',
      id: 16,
      number: 17,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'Suspended',
      method: { type: 'CreditCardRefund' },
      type: 'CreditNote',
      id: 17,
      number: 18,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'Suspended',
      method: { type: 'BankTransferRefund' },
      type: 'CreditNote',
      id: 18,
      number: 19,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'Suspended',
      method: { type: 'DeductedInvoiceRefund' },
      type: 'CreditNote',
      id: 19,
      number: 20,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'FailedCanRetry',
      method: { type: 'NemkontoRefund' },
      type: 'CreditNote',
      id: 20,
      number: 21,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'FailedCanRetry',
      method: { type: 'CreditCardRefund' },
      type: 'CreditNote',
      id: 21,
      number: 22,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'FailedCanRetry',
      method: { type: 'BankTransferRefund' },
      type: 'CreditNote',
      id: 22,
      number: 23,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
    {
      status: 'FailedCanRetry',
      method: { type: 'DeductedInvoiceRefund' },
      type: 'CreditNote',
      id: 23,
      number: 24,
      billingAccountNumber: 204392007,
      totalInclVat: { amount: 1571.6, currencyCode: 'DKK' },
      remainingInclVat: { amount: 400.6, currencyCode: 'DKK' },
      createdAtDate: '2021-03-05T00:00:00',
      lines: [],
      products: ['TV', 'MOBILE'],
    },
  ],
};
